"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMeasurementProvider = void 0;
const isMeasurementProvider = (c) => { return typeof c.getMeasurements === 'function'; };
exports.isMeasurementProvider = isMeasurementProvider;
//# sourceMappingURL=measurement.provider.js.map